/* Penoblo „Kuratiert für dich" – Tab-Karussell.
   Pill-Tabs, seitenweises Karussell (perView responsiv), Pfeile + Dots,
   Quick-Add (AJAX) fuer Einzelprodukte. */
class PnbFeaturedTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('.cur__tab')];
    this.tabsWrap = this.querySelector('.cur__tabs');
    this.panels = [...this.querySelectorAll('[data-panel]')];
    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next]');
    this.dotsWrap = this.querySelector('[data-dots]');
    this.allLink = this.querySelector('[data-all]');
    this.tab = 0;
    this.page = 0;
    this.perView = this.calcPer();
    this._native = this.nativeScroll();

    this.tabs.forEach((t) => t.addEventListener('click', () => this.activate(parseInt(t.dataset.tab, 10))));
    if (this.tabsWrap) this.tabsWrap.addEventListener('keydown', (e) => {
      const i = this.tabs.indexOf(document.activeElement);
      if (i < 0) return;
      const n = e.key === 'ArrowRight' ? (i + 1) % this.tabs.length
        : e.key === 'ArrowLeft' ? (i - 1 + this.tabs.length) % this.tabs.length
        : e.key === 'Home' ? 0 : e.key === 'End' ? this.tabs.length - 1 : -1;
      if (n < 0) return;
      e.preventDefault(); this.activate(n); this.tabs[n].focus();
    });
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.page - 1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.page + 1));
    this._onResize = () => {
      const p = this.calcPer();
      const native = this.nativeScroll();
      // Auch beim Wechsel JS-Paging <-> natives Scrollen (749px) zuruecksetzen,
      // sonst bleibt ein veralteter transform-/Seitenstand haengen.
      if (p !== this.perView || native !== this._native) {
        this.perView = p; this._native = native; this.page = 0; this.render();
      }
    };
    window.addEventListener('resize', this._onResize, { passive: true });
    // Quick-Add laeuft jetzt zentral ueber assets/pnb-quick-add.js ([data-add]-Delegation)

    // Touch-Swipe (Mobile): horizontal wischen blättert eine Seite weiter
    let sx = 0, sy = 0;
    this.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    this.addEventListener('touchend', (e) => {
      if (this.nativeScroll()) return; // Mobile: natives Scrollen uebernimmt
      if (!e.target.closest('.cur__viewport')) return; // Wischen in der Tab-Leiste blaettert nicht
      const dx = e.changedTouches[0].clientX - sx;
      const dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) this.go(this.page + (dx < 0 ? 1 : -1));
    }, { passive: true });

    this.activate(0);
  }

  calcPer() { const w = window.innerWidth; return w <= 480 ? 1 : w <= 760 ? 2 : w <= 1080 ? 3 : 4; }
  // Mobile: natives Scroll-Snap-Wischen statt JS-Transform-Paging
  nativeScroll() { return window.matchMedia('(max-width: 749px)').matches; }
  activePanel() { return this.panels[this.tab]; }
  track() { const p = this.activePanel(); return p && p.querySelector('.cur__track'); }
  cellCount() { const t = this.track(); return t ? t.children.length : 0; }
  pageCount() { return Math.max(1, Math.ceil(this.cellCount() / this.perView)); }

  activate(i) {
    if (i == null || !this.panels[i]) return;
    this.tab = i;
    this.page = 0;
    this.tabs.forEach((t, k) => { t.classList.toggle('on', k === i); t.setAttribute('aria-selected', k === i); t.tabIndex = k === i ? 0 : -1; });
    this.panels.forEach((p, k) => { p.hidden = k !== i; });
    if (this.allLink && this.panels[i].dataset.url) this.allLink.href = this.panels[i].dataset.url;
    this.centerTab(i);
    this.render();
  }

  // aktiven Tab in der (auf Mobil scrollbaren) Tab-Leiste sichtbar zentrieren
  centerTab(i) {
    const w = this.tabsWrap, t = this.tabs[i];
    if (!w || !t || w.scrollWidth <= w.clientWidth + 4) return;
    w.scrollTo({ left: t.offsetLeft - (w.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
  }

  go(p) { const max = this.pageCount() - 1; this.page = Math.min(max, Math.max(0, p)); this.render(); }

  render() {
    const t = this.track();
    if (!t) return;
    if (this.nativeScroll()) {
      t.style.transform = '';                 // natives Scrollen, kein Transform
      if (t.parentElement) t.parentElement.scrollLeft = 0;
    } else {
      t.style.transform = `translateX(${-this.page * 100}%)`;
    }
    const max = this.pageCount() - 1;
    if (this.prevBtn) this.prevBtn.disabled = this.page <= 0;
    if (this.nextBtn) this.nextBtn.disabled = this.page >= max;
    this.renderDots(max + 1);
  }

  renderDots(n) {
    if (!this.dotsWrap) return;
    if (n <= 1) { this.dotsWrap.innerHTML = ''; this.dotsWrap.hidden = true; return; }
    this.dotsWrap.hidden = false;
    this.dotsWrap.innerHTML = '';
    for (let i = 0; i < n; i++) {
      const b = document.createElement('button');
      b.className = 'cur__dot' + (i === this.page ? ' on' : '');
      if (i === this.page) b.setAttribute('aria-current', 'true');
      b.setAttribute('aria-label', (this.dotsWrap.dataset.pageLabel || 'Seite [n]').replace('[n]', i + 1));
      b.addEventListener('click', () => this.go(i));
      this.dotsWrap.appendChild(b);
    }
  }

  disconnectedCallback() {
    if (this._onResize) window.removeEventListener('resize', this._onResize);
  }
}
if (!customElements.get('pnb-featured-tabs')) customElements.define('pnb-featured-tabs', PnbFeaturedTabs);
